function NosValeursHistoire() {
    return (
        <div className="text-center py-10">
            <div className="mb-8">
                <h2 className="font-comme font-semibold text-[28px] md:text-[32px] leading-[38px] text-gris-sombre dark:text-blanc-sombre">
                    Nos <span className="text-bleu-je">valeurs</span>
                </h2>
            </div>
            <div className="flex flex-col md:flex-row justify-center gap-10 md:gap-[93px]">
                <div className="flex flex-col items-center gap-5">
                    <img src="../images/innovation.svg" alt="innovation" className="mb-2.5 w-[80px] h-auto md:w-auto" />
                    <h3 className="w-[124px] h-[52px] font-comme text-[20px] md:text-[24px] leading-[32px] text-center text-bleu-je">Innovation</h3>
                </div>
                <div className="flex flex-col items-center gap-5">
                    <img src="../images/humain.svg" alt="humain" className="mb-2.5 w-[80px] h-auto md:w-auto" />
                    <h3 className="w-[124px] h-[52px] font-comme text-[20px] md:text-[24px] leading-[32px] text-center text-bleu-je">Humain</h3>
                </div>
                <div className="flex flex-col items-center gap-5">
                    <img src="../images/partage.svg" alt="partage" className="mb-2.5 w-[80px] h-auto md:w-auto" />
                    <h3 className="w-[124px] h-[52px] font-comme text-[20px] md:text-[24px] leading-[32px] text-center text-bleu-je">Partage</h3>
                </div>
            </div>
        </div>
    );
}

function Timeline({ date, texte }) {
    return (
        <div className="flex flex-col md:flex-row items-center md:items-start gap-3 md:gap-5 mb-5 bg-gris-clair dark:bg-bleu-gris p-4 rounded">
            <div className="hidden md:block w-0 h-[156px] border border-gris-sombre">
                <img src="../images/trait.svg" alt="Trait" className="w-0 h-[156px]" />
            </div>
            <div className="flex flex-col items-center md:items-start bg-gris-clair dark:bg-bleu-gris">
                <div className="relative font-bold text-[36px] md:text-[48px] leading-[40px] md:leading-[49px] text-bleu-je dark:text-fond-sombre tracking-[-1px] mb-2 md:mb-10">
                    <h3>{date}</h3>
                </div>
                <div className="w-[180px] md:w-[118px] text-[13px] leading-[16px] text-gris-sombre dark:text-fond-sombre text-center md:text-left mt-2 md:mt-5">
                    <p>{texte}</p>
                </div>
            </div>
        </div>
    );
}

function NotreHistoire() {
    const anneeEnCours = new Date().getFullYear();

    const dates = [
        { date: "2007", texte: "Création de la Junior-Entreprise i2c" },
        { date: "2008", texte: "Passage Junior-Création" },
        { date: "2010", texte: "Passage Junior-Entreprise" },
        { date: "2011", texte: "Lauréat du prix du meilleur espoir" },
        { date: "2013", texte: "Signature du partenariat avec les JEB" },
        { date: anneeEnCours.toString(), texte: "L'histoire continue" }
    ];

    return (
        <div className="text-center pb-[30px] pt-[45.3px] bg-white dark:bg-gris-sombre">
            <div className="mb-8">
                <h2 className="font-comme font-semibold text-[28px] md:text-[32px] leading-[38px] text-gris-sombre dark:text-blanc-sombre">
                    Notre <span className="text-bleu-je">histoire</span>
                </h2>
            </div>
            <div className="flex flex-col md:flex-row md:flex-wrap items-center justify-center gap-5">
                {dates.map((d, index) => (
                    <Timeline key={index} date={d.date} texte={d.texte} />
                ))}
            </div>
        </div>
    );
}

export { NosValeursHistoire, NotreHistoire };